import { getProducerAdvisor, requestProducerAdvisor } from '@/api/ibModule';

export default {
  namespaced: true,

  state: () => ({
    advisor: null,
    loaded: false,
  }),

  getters: {
    advisor: (state) => state.advisor,
    hasAdvisor: (state) => !!state.advisor,
    advisorLoaded: (state) => state.loaded,
  },

  mutations: {
    setAdvisor(state, advisor) {
      state.advisor = advisor || null;
      state.loaded = true;
    },
  },

  actions: {
    async fetchAdvisor({ commit }) {
      const { advisor } = await getProducerAdvisor();
      commit('setAdvisor', advisor);
    },

    async submitRequest({ commit }, payload) {
      const result = await requestProducerAdvisor(payload);
      commit('setAdvisor', result.advisor);
      return result;
    },
  },
};
